import { ROLES } from '@/features/auth/constants/roles';
import type { Role } from '@/features/auth/constants/roles';

export const preRegistrationRoutes = {
  accommodations: '/preinscripciones/alojamientos',
  municipalLists: '/preinscripciones/listados',
  newMunicipalList: '/preinscripciones/listados/nuevo',
  municipalList: (listId: string) => `/preinscripciones/listados/${listId}`,
  accommodation: (listId: string, accommodationId: string) =>
    `/preinscripciones/listados/${listId}?fila=${accommodationId}`,
};

// Mirrors the backend roles of the pre-registration endpoints
export const PRE_REGISTRATION_VIEW_ROLES: Role[] = [
  ROLES.ADMIN,
  ROLES.FISCALIZACION_EDITOR,
  ROLES.OBSERVATORIO_EDITOR,
  ROLES.FISCALIZACION_LECTOR,
  ROLES.OBSERVATORIO_LECTOR,
];

export const PRE_REGISTRATION_EDIT_ROLES: Role[] = [
  ROLES.ADMIN,
  ROLES.FISCALIZACION_EDITOR,
  ROLES.OBSERVATORIO_EDITOR,
];
